module.exports = __webpack_public_path__ + "static/img/wx.7d5a1fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wx.png
// module id = KB7T
// module chunks = 14